type QueryParamValue = string | number | boolean | null | undefined;

export const generateUrl = (path: string, params?: Record<string, QueryParamValue>): string => {
  if (!params) {
    return path;
  }

  const query = Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');

  return query ? `${path}?${query}` : path;
};
